import React from 'react';

import { SVGComponentProps } from './svg.types';

const SelectSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5445 15.0087L7.41216 11.4498C7.24448 11.2852 7.13268 11.0791 7.09043 10.8568C7.04817 10.6344 7.07731 10.4054 7.17426 10.1977C7.27121 9.99008 7.43178 9.81278 7.63633 9.68751C7.84088 9.56223 8.08056 9.49442 8.32605 9.49236L16.7925 9.3809C17.0369 9.37771 17.277 9.43984 17.4835 9.55975C17.69 9.67965 17.8542 9.85218 17.956 10.0564C18.0578 10.2606 18.093 10.4878 18.0572 10.7103C18.0214 10.9328 17.9162 11.1412 17.7544 11.31L13.7172 14.9801C13.5814 15.121 13.4151 15.2344 13.229 15.3129C13.043 15.3915 12.8412 15.4334 12.6367 15.4361C12.4321 15.4388 12.2293 15.4022 12.0413 15.3286C11.8532 15.255 11.684 15.146 11.5445 15.0087Z"
          fill={fill}
        />
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke={fill} />
      </svg>
    </span>
  );
};

export default SelectSVG;
